import { createEffect } from 'effector';
import axios from 'axios';
import { api } from '../../api/axiosinstance.js';

export const getCHPointsFx = createEffect().use(async () => {
  return (await api(false).get('/bcc/data/feature-collection')).data;
});

export const getCHComplexesFx = createEffect().use(async (payload) => {
  return (
    await axios.get(
      `https://center-home.kz:8443/api/v1/residential-complexes/city/${payload}`
    )
  ).data;
});

export const getCHCitiesFx = createEffect().use(async () => {
  return (await axios.get('https://center-home.kz:8443/api/v1/cities')).data;
});

export const getCHHexagonsFx = createEffect().use(async () => {
  return (await api(false).get('/bcc/data/hex-price')).data;
});

export const getCHDistrictsFx = createEffect().use(async (payload) => {
  return (
    await axios.get(
      `https://center-home.kz:8443/api/v1/districts/city/${payload || 2}`
    )
  ).data;
});
